import React, {useState} from 'react';
import './DealerSubmission.css';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  updateDealerLeadStatusMessage,
  updateDealerLeadSubmitted,
  updateDealerNotes,
  updateEmail,
  updatePhoneNumber,
  updatePreferredContactMethod,
  updateShowPreQualificationAmount,
  updateToggleDealerConfirmationDialog,
  updateToggleDealerConnectDialog,
  updateToggleDealerSubmissionDialog
} from '../../redux/app-state-slice';
import {sendDealerLead} from '../../Services/SendDealerLeadService/SendDealerLeadService';
import {checkIfPhoneNumberIsValid} from '../../validation/FormValidation';
import {initialState} from '../../redux/initialState';
import FoMoToggleButton from '../Toggle/Toggle';
import Checkbox from '../Checkbox/Checkbox';
import DealerInquirySummary from '../DealerInquirySummary/DealerInquirySummary';
import Button from '../Button/Button';
import RadioButton from '../RadioButton/RadioButton';
import Input from '../Input/Input';

export const sendDealerLeadData = async (customerData, appConfig, navigate, dispatch) => {
  await sendDealerLead(customerData, appConfig).then((response) => {
    dispatch(updateDealerLeadStatusMessage(response.message));
    dispatch(updateToggleDealerSubmissionDialog(false));
    dispatch(updateToggleDealerConfirmationDialog(true));
  });
};

export const onChangeLinkClicked = (e, dispatch) => {
  dispatch(updateToggleDealerSubmissionDialog(false));
  dispatch(updateToggleDealerConnectDialog(true));
};

function DealerSubmission({dispatch, customerData, appConfig}) {
  const navigate = useNavigate();
  const [termsAndConditionsChecked, setTermsAndConditionsChecked] = useState(false);
  const termsAndConditionsLink = (url) => {
    window.open(url, '_blank');
  };

  const onToggle = () => {
    dispatch(updateShowPreQualificationAmount(!customerData?.showPreQualificationAmount?.value));
  };

  return (
    <>
      <div className='prequal--web--dealer-submission-parent-container-fomo' data-testid='dealer-submission-container'>
        <div className='prequal--web--dealer-form-container'>
          <div className='prequal--web--dealer-form-inputs-container-fomo'>
            <div className='prequal--web--selected-dealer-container-fomo'>
              <span className='prequal--web--select-dealer-text-fomo'>Your Selected Dealer</span>
              <div className='prequal--web--dealer-name-container-fomo'>
                <span className='prequal--web--dealer-name-fomo'>{customerData?.selectedDealer?.value?.vendorName}</span>
                <Button label='Change Dealer' dataTestId='change-dealer-fomo' onClick={(event) => onChangeLinkClicked(event, dispatch)} />
              </div>
            </div>
            <div className='prequal--web--section-line prequal--web--hide-mobile' />
            <div>
              <div className='prequal--web--dealer-contact-form-container'>
                <div className='prequal--web--dealer-form-section-title-container'>
                  <span className='prequal--web--dealer-form-section-title-fomo'>
                    <span className='prequal--web--contact-info-hide-desktop'>Your&nbsp;</span>
                    Contact Info
                  </span>
                  <span className='prequal--web--dealer-form-section-description-fomo'>
                    Please select your preferred contact method below. Your dealer will contact you to confirm your appointment.
                  </span>
                </div>
                <div className='prequal--web--dealer-form-section-container-fomo'>
                  <div className='prequal--web--input-container'>
                    <div className='form-floating prequal--wc--last-name-input-container'>
                      <Input
                        type='text'
                        id='Phone Number'
                        maxLength='40'
                        onInputChangeHandler={(e) => dispatch(updatePhoneNumber(e.target.value))}
                        onBlurChangeHandler={(e) => dispatch(updatePhoneNumber(e.target.value.trim()))}
                        name='phoneNumber'
                        dataTestId='phoneNumber'
                        value={customerData?.phoneNumber?.value}
                        placeholder='Phone Number'
                        className='prequal--web--prequal-form-text-input'
                      />
                      <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='phoneNumber'>
                        Phone Number (Optional)
                      </label>
                    </div>
                    <p id='prequal--wc--error-message' className='prequal--wc--error-message'>
                      {customerData?.phoneNumber?.errorMessage}
                    </p>
                  </div>
                  <div className='prequal--web--input-container'>
                    <div className='form-floating prequal--wc--last-name-input-container'>
                      <Input
                        type='text'
                        maxLength='40'
                        onInputChangeHandler={(e) => dispatch(updateEmail(e.target.value))}
                        onBlurChangeHandler={(e) => dispatch(updateEmail(e.target.value.trim()))}
                        name='emailAddress'
                        dataTestId='emailAddress'
                        value={customerData?.email?.value}
                        placeholder='Email'
                        className='prequal--web--prequal-form-text-input'
                      />
                      <label className='prequal--wc--prequal-form-label prequal--web--prequal-form-label-dark' htmlFor='emailAddress'>
                        Email Address
                      </label>
                    </div>
                    <p id='prequal--wc--error-message' className='prequal--wc--error-message'>
                      {customerData.email.errorMessage}
                    </p>
                  </div>
                  <div className='prequal--web--input-container'>
                    <span className='prequal--web--input-label-text-fomo'>Preferred Contact Method</span>
                    <div className='prequal--web--preferred-contact-radio-container-fomo'>
                      <RadioButton
                        type='radio'
                        name='Email'
                        checked={customerData?.preferredContactMethod?.value === 'Email'}
                        onChange={(e) => dispatch(updatePreferredContactMethod(e.target.value))}
                      />
                      <RadioButton
                        type='radio'
                        name='Phone'
                        checked={customerData?.preferredContactMethod?.value === 'Phone'}
                        onChange={(e) => dispatch(updatePreferredContactMethod(e.target.value))}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='prequal--web--section-line' />
            <div className='prequal--web--prequalification-details-container-fomo'>
              <div className='prequal--web--dealer-form-section-title-container'>
                <span className='prequal--web--dealer-form-section-title-fomo'>Pre-Qualification Details</span>
                <span className='prequal--web--dealer-form-section-description-fomo'>
                  Choose the pre-qualification details you’d like to share with your dealer.
                </span>
              </div>
              <div className='prequal-web-toggle-container-fomo'>
                <span>Total prequalification amount</span>
                <FoMoToggleButton
                  initialState={customerData?.showPreQualificationAmount?.value}
                  onToggle={onToggle}
                  testId='show-fomo-prequal-amount-toggle'
                />
              </div>
            </div>
            <div className='prequal--web--section-line' />
            <div className='prequal--web--dealer-notes-container'>
              <div className='prequal--web--dealer-form-section-title-container'>
                <span className='prequal--web--dealer-form-section-title-fomo'>
                  <span className='prequal--web--hide-mobile'>Notes to dealer</span>
                  <span className='prequal--web--hide-desktop'>Notes to dealer(Optional)</span>
                </span>
                <span className='prequal--web--dealer-form-section-description-fomo'>
                  Tell the dealer what you&lsquo;re expecting from them, add a question or a special request.
                </span>
              </div>
              <div className='prequal--web--dealer-notes-input-container'>
                <textarea
                  maxLength='300'
                  rows='5'
                  placeholder='Enter Message'
                  className='prequal--web--dealer-notes-fomo'
                  value={customerData?.dealerNotes?.value}
                  onChange={(e) => dispatch(updateDealerNotes(e.target.value))}
                />
                <span className='prequal--web--character-count-fomo'>
                  {customerData?.dealerNotes?.value?.length ? 300 - customerData.dealerNotes.value.length : 300} characters left
                </span>
              </div>
            </div>
          </div>
          <div className='prequal--web--inquiry-summary-container-submission'>
            <DealerInquirySummary
              dispatch={dispatch}
              customerData={customerData}
              appConfig={appConfig}
              className='prequal--web--dealer-submission-page-summary-container-height'
            />
          </div>
        </div>
        <div className='prequal--web--dealer-terms-container-fomo'>
          <div className='prequal--web--terms-and-conditions-box'>
            <label htmlFor='checkbox-soft-inquiry-consent' className='prequal--web--consent-text-fomo'>
              <Checkbox
                type='checkbox'
                id='checkbox-soft-inquiry-consent'
                name='checkbox-soft-inquiry-consent'
                dataTestId='inquiryConsent'
                checked={termsAndConditionsChecked}
                onChange={() => setTermsAndConditionsChecked(!termsAndConditionsChecked)}
              />
              <span>I accept the Ford Credit Terms and Conditions</span>
            </label>
            <p className='prequal--web--terms-and-conditions-text-fomo'>
              When you click the Submit Inquiry button, you are directing us to share your information you provided with{' '}
              {customerData?.selectedDealer?.value?.vendorName}. To help streamline your purchase experience, and understand the information
              will be subject to the dealer’s privacy policy. See our{' '}
              <a
                href='./terms-and-conditions'
                className='prequal--web--terms-and-conditions-link'
                onClick={(e) => {
                  e.preventDefault();
                  termsAndConditionsLink('./terms-and-conditions');
                }}
              >
                Terms and Conditions
              </a>
              .
            </p>
          </div>
        </div>
        <div className='prequal-web-dealer-submit-inquiry-button'>
          <Button
            id='dealer-lead-sumit-button'
            label='Submit Inquiry'
            buttonStyle='primary'
            dataTestId='submit-inquiry-button'
            onClick={() => {
              sendDealerLeadData(customerData, appConfig, navigate, dispatch);
              dispatch(updateDealerLeadSubmitted(true));
            }}
            className='prequal-web-dealer-lead-page-submit-fomo'
            disabled={!termsAndConditionsChecked || !checkIfPhoneNumberIsValid(customerData)}
          />
        </div>
      </div>
    </>
  );
}

DealerSubmission.propTypes = {
  customerData: PropTypes.object,
  dispatch: PropTypes.func,
  appConfig: PropTypes.object
};

DealerSubmission.defaultProps = {
  customerData: initialState,
  dispatch: null,
  appConfig: null
};
export default DealerSubmission;
